import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { selectTopmenu, selectLeftmenu } from '../../store/actions2';
// import './top.css'
import { inkScreenPages } from '../../menu';

const TopMenu = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const menuData = useSelector((state: any) => state.menuData);
    const [menuJson, setMenuJson] = useState<any>({})

    useEffect(() => {
        setMenuJson(menuData.menuAll);


        // Object.keys(menuData.menuAll).map((key: any) => (
        //     console.log(menuData.menuAll[key])
        // ))
    }, [menuData.menuAll])

    const handleSubMenu = (menuObj: any) => {
        if (menuObj.subMenu) {
            const firstPropName = Object.keys(menuObj.subMenu)[0];
            const subMenuObj = menuObj.subMenu[firstPropName];
            handleSubMenu(subMenuObj);
        } else {
            // 处理没有 subMenu 的情况
            dispatch(selectLeftmenu(menuObj.id));
            navigate(menuObj.path + '/');
        }
    }

    // 点击菜单项触发状态改变
    function handleSelect(menu: any) {
        dispatch(selectTopmenu(menu));

        const obj1 = menuData.menuAll[menu]
      

        if (obj1) {
            handleSubMenu(obj1)
        }

        document.querySelector("body")?.classList.add("main-sidebar-show");
        document.querySelector("body")?.classList.remove("main-sidebar-hide");
    }


    // const routeChange = useCallback(() => {
    //     let path = `${process.env.PUBLIC_URL}/${meetingRoomPages.dashboard.path}`;
    //     navigate(path);
    // }, [navigate])

    // every chnage this effect calls
    let menuIcontype = "";
    const body = document.querySelector("body")
    if (body?.classList.contains("horizontalmenu")) {
        menuIcontype = "hor-icon";
    } else {
        menuIcontype = "sidemenu-icon";
    }

    return (
        <div style={{ overflowX: 'auto' }}>
            <Nav variant="pills" activeKey={menuData.topMenu} onSelect={handleSelect} style={{ flexDirection: 'initial', whiteSpace: 'nowrap' }}>
                {Object.keys(menuJson).map((key: any) => (
                    <Nav.Link key={menuJson[key]["id"]} style={{ marginLeft: '1rem', borderRadius: '6px' }} eventKey={menuJson[key]["id"]}>
                        <i className={`${menuJson[key].icon} ${menuIcontype} menu-icon`}></i>
                        <span className="sidemenu-label" style={{ marginLeft: '5px' }}>
                            {menuJson[key]["text"]}
                        </span>
                    </Nav.Link>
                ))}
            </Nav>
        </div>
    );
}

export default TopMenu